import { render, staticRenderFns } from "./QFormBuilder.vue?vue&type=template&id=b921b3fc&"
import script from "./QFormBuilder.vue?vue&type=script&lang=js&"
export * from "./QFormBuilder.vue?vue&type=script&lang=js&"
import style0 from "./QFormBuilder.vue?vue&type=style&index=0&id=b921b3fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports